import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthContext from "../context/AuthContext";



export default function OAuthRedirect() {
  const navigate = useNavigate();
   const [user, setUser] = useState(null);
    const [userInfo, setUserInfo] = useState(null);
    const { login } = useContext(AuthContext);

  useEffect(() => {
    const url = new URL(window.location.href);
    const token = url.searchParams.get("token");
    const apiUrl = process.env.REACT_APP_API_URL_SSO;
   
  
    if (token) {
        localStorage.setItem("token", token);
        const userId = url.searchParams.get("id");
        const fetchUrl = apiUrl + '/users/data/' + userId;
  
        fetch(fetchUrl, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
          mode: 'cors'
        })
          .then((res) => {
            if (!res.ok) throw new Error("Erreur d'authentification");
            return res.json();
          })
          .then((data) => {       
            if (data) {
              const userInfo = {
                id: data.id,
                email: data.email,
                photo: data.usrPicture,
                firstName: data.usrFirstname,
                lastName: data.usrLastname,
                usrCreatedAt: {date:data.usrCreatedAt},
                sctMyUnisoftId: data.usrSociety?.sctMyUnisoftId || null
              };
              data.userInfo = userInfo;
              setUserInfo(userInfo);
              
              const userData = {
                token: token,
                role: data.userData.role,
                userInfo: data.userData,
            };

             
            try {
              login(userData); 
              
              Promise.resolve().then(() => {
                navigate("/");
              });
            } catch (e) {
              console.error("Erreur d'enregistrement dans localStorage", e);
            }
            } else {
              console.warn("Données utilisateur incomplètes :", data);
            }
            
          })
          .catch((err) => {
            console.error("Erreur utilisateur :", err);
          });
      }
    }, [navigate]);

  return <div></div>;
};
